/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters } from '@wordpress/hooks'

/**
 * External dependencies
 */
import { AccordionIcon } from '~cartzillagb/icons'
import { range } from '~cartzillagb/util'
import {
	disabledBlocks,
	i18n
} from 'cartzillagb'

/**
 * Internal dependencies
 */
import edit from './edit'
import save from './save'

const schema = {
	enableContainer: {
		type: 'boolean',
		default: false,
	},
	limit: {
		type: 'number',
		default: 3
	},
}

const maxLimit = applyFilters( 'cartzillagb.accordion.max.limit', 12 )

{ range( 1, maxLimit + 1 ).forEach( i => {

	schema[ `accordionTitle${ i }` ] = {
		type: 'string',
	}

	schema[ `accordionDesc${ i }` ] = {
		type: 'string',
	}

} ) }

export const name = 'czgb/accordion'

export const settings = {
	title: __( 'Accordion', i18n ),
	description: __( 'A title that your visitors can toggle to view more text. Use as FAQs or multiple ones for an Accordion.', i18n ),
	icon: AccordionIcon,
	category: 'cartzillagb',
	example: {},
	keywords: [
		__( 'Accordion', i18n ),
		__( 'Toggle', i18n ),
		__( 'CartzillaGB', i18n ),
	],
	attributes: schema,
	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	},

	edit,
	save,

	// CartzillaGB modules.
	modules: {
		'advanced-responsive': true,
		'block-title': true,
	},
}
